import { ScrollBarCaret } from "./parts/view-caret";
import { ScrollBarThumb } from "./parts/view-thumb";
import { ScrollBarTrack } from "./parts/view-track";
import { ScrollBarRoot } from "./scroll-bar";

export type * from "./types-scroll-bar";

/** Barra de rolagem de um elemento rolável (`ScrollBar.Root` com `scrollerRef`); as partes só entram para compor outra disposição. */
export const ScrollBar = {
  Root: ScrollBarRoot,
  Track: ScrollBarTrack,
  Thumb: ScrollBarThumb,
  Caret: ScrollBarCaret,
};
